import 'vuetify/styles'               // Required CSS
import { createVuetify } from 'vuetify'

// Import any Vuetify components or directives you want to use (optional)
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
  },
})
